import React, { Component } from "react";
import ReCAPTCHA from "react-google-recaptcha";
import Layout from "../../components/Layout";
import Meta from "../../components/Meta";
import MenuEN from "../../components/en/MenuEN";
import FooterEN from "../../components/en/FooterEN";
import Error from "../../components/Error";
import Success from "../../components/Success";
import Map from "../../components/Map"
import { validateForm } from "../../utils/validation";
import { getHost } from '../../utils/request'

class Index extends Component {
    constructor(props) {
        super(props);

        this.state = {
            firstName: "",
            lastName: "",
            email: "",
            phone: "",
            message: "",
            privacy: false,
            captcha: null,
            error: null,
            success: null
        };
    }

    handleChange(e) {
        let change = {}
        change[e.target.name] = e.target.value
        this.setState(change)
    }

    onRecaptchaChange(value) {
        this.state.captcha = value;
      }

    handleSubmit = async e => {
        e.preventDefault();

        var error = validateForm(
                        this.state.firstName, this.state.lastName, 
                        this.state.email, this.state.message, 
                        this.state.privacy, this.state.phone);
        if (error) {
          this.setState({ 
            error: error,
            success: null
          });
          return false;
        }
  
        const formData = new FormData();
        formData.append('file', null);
        formData.append('firstName', this.state.firstName);
        formData.append('lastName', this.state.lastName);
        formData.append('email', this.state.email);
        formData.append('phone', this.state.phone);
        formData.append('message', this.state.message);
  
        const options = {
          method: 'POST',
          body: formData,
        };
  
        fetch(getHost() + "/sendform", options)
        .then((responseJson) => {
        })
        .catch((error) => {
          this.setState({ 
            error: "Impossible to send the email",
            success: null
          });
          return false;
        });
    
        this.setState({
            firstName: "",
            lastName: "",
            email: "",
            phone: "",
            message: "",
            //captcha: null,
            privacy: null,
            success: "Email sent successfully",
            error: null
        });
    };

    render() {
        const { success, error, firstName, lastName, email, phone, message, privacy } = this.state;
        return (
            <Layout>
                <Meta
                    title={"How to reach us"}
                    description={"How to reach our office or contact us by e-mail or telephone."}
                    url={"https://www.coeladvocaten.be/en/contact"}
                    robots={"index, follow"}
                    languages={[
                        { url:"https://www.coeladvocaten.be/nl/contact", language:"nl" },
                        { url:"https://www.coeladvocaten.be/fr/contact", language:"fr" },
                        { url:"https://www.coeladvocaten.be/en/contact", language:"en" }
                    ]}
                />

                <MenuEN
                    switchUrlNL="/nl/contact"
                    switchUrlFR="/fr/contact"
                />

                <div className="page">
                    <div className="header">
                        <div className="grayscale background background-contact"></div>
                        <div className="slider">
                            <h1>Contact</h1>
                            <h2>Coel Advocaten</h2>
                            <p></p>
                        </div>
                    </div>

                    <div className="content">
                        <div className="container press">
                            <div className="row"><br /></div>
                            <div className="row">
                                <div className="col-xl-12 col-md-12 col-sm-12">   				
                                    <p>For the first consultation, you can make an appointment by phone or email. You can also contact us by filling out the form below.</p>
                                </div>
                            </div>
                            <div className="row"><br /></div>
                            <div className="row">
                                <div className="col-xl-4 col-md-4 col-sm-12">
                                    <div className="background img-contact">
                                    </div>

                                    <div className="img-contact-slider">
                                        <p className="img-contact-slider-title">
                                            <i className="fa fa-map-marker"></i> Address
                                        </p>
                                        <p className="img-contact-slider-content">
                                            78, Schuttersvest, 2800 Mechelen, Belgium
                                        </p>
                                        <p><br /></p>
                                        <p className="img-contact-slider-title">
                                            <i className="fa fa-envelope"></i> E-mail
                                        </p>
                                        <p className="img-contact-slider-content">
                                           info@coeladvocaten.be
                                        </p>
                                        <p><br /></p>
                                        <p className="img-contact-slider-title">
                                            <i className="fa fa-phone"></i> Phone
                                        </p>
                                        <p className="img-contact-slider-content">
                                            +32 15 41 76 36
                                        </p>
                                    </div>
                                
                                </div>
                                <div className="col-xl-8 col-md-8 col-sm-12">                             
                                    <form className="form" onSubmit={this.handleSubmit}>
                                        <div className="row">
                                            <div className="col-md-6 col-sm-12 col-xs-12">
                                                <div>
                                                    <label><strong>First Name</strong></label>
                                                    <input type="text" name="firstName" required="" onChange={this.handleChange.bind(this)} value={firstName} />
                                                </div>                                  
                                            </div>
                                            <div className="col-md-6 col-sm-12 col-xs-12">
                                                <div>
                                                    <label><strong>Last Name</strong></label>
                                                    <input type="text" name="lastName" required="" onChange={this.handleChange.bind(this)} value={lastName} />
                                                </div>                                  
                                            </div>
                                        </div>
                                        <div className="row"><br /></div>
                                        <div className="row">
                                            <div className="col-md-6 col-sm-12 col-xs-12">
                                                <div>
                                                    <label><strong>E-mail</strong></label>
                                                    <input type="text" name="email" required="" onChange={this.handleChange.bind(this)} value={email} />
                                                </div>                                  
                                            </div>
                                            <div className="col-md-6 col-sm-12 col-xs-12">
                                                <div>
                                                    <label><strong>Phone</strong></label>
                                                    <input type="text" name="phone" onChange={this.handleChange.bind(this)} value={phone} />
                                                </div>                                  
                                            </div>
                                        </div>
                                        <div className="row"><br /></div>
                                        <div className="row">
                                            <div className="col-md-12 col-sm-12 col-xs-12">
                                                <div>
                                                    <label><strong>Message</strong></label>
                                                    <textarea name="message" required="" onChange={this.handleChange.bind(this)} value={message} />
                                                </div>                                  
                                            </div>
                                        </div>
                                        <div className="row"><br /></div>
                                        <div className="row">
                                            <div className="col-md-12 col-sm-12 col-xs-12">
                                                <div className="privacy">
                                                    <input type="checkbox" name="privacy" onChange={this.handleChange.bind(this)} checked={privacy}/>&nbsp;<label>I have read and I accept the terms and conditions appearing on the <a href="/en/privacy-policy">Privacy Protection</a> page. <strong>*</strong></label>
                                                </div>   
                                            </div>
                                        </div>
                                        <div className="row"><br /></div>
                                        <div className="row">
                                            <div className="col-md-12 col-sm-12 col-xs-12">
                                                <div className="privacy">
                                                    <ReCAPTCHA
                                                        sitekey="6LdEGcoUAAAAAD-UHXylA7SrN_nOgyeyVwCfMW_-"
                                                        hl='en'
                                                        onChange={this.onRecaptchaChange}
                                                    />
                                                </div>   
                                            </div>
                                        </div>
                                        <div className="row"><br /></div>
                                        <div className="row">
                                            <div className="col-md-12 col-sm-12 col-xs-12">
                                                <div>
                                                    <button type="submit" className="button-contact">Send</button>
                                                </div>                                  
                                            </div>
                                        </div>
                                        <div className="row">
                                            <div className="col-md-12 col-sm-12 col-xs-12">
                                                {error && <Error message={error} />}
                                                {success && <Success message={success} />}  
                                            </div>
                                        </div>
                                        
                                    </form>
                                </div>

                                <div className="col-xl-12 col-md-12 col-sm-12">
                                    <div className="row"><br /></div>
                                    <div className="row">
                                        <div className="col-md-12 col-sm-12 col-xs-12">
                                            <Map 
                                                message="You are here"
                                            />                              
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>                    
                </div>

                <FooterEN />
            </Layout>
        );
    }
}

export default Index;
